import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../environments/environment';

/**
 * Minimal Fabric shape — only the fields Cost Analysis needs.
 * Mirrors `FabricDto` from Item.API. Extend as other features need more.
 */
export interface FabricDto {
  id?: string;
  fabricCode?: string;
  longDescription?: string;
  fabricTypeCode?: string;
  gramsPerSquareMeter?: number;
  commercialFabricDescription?: string;
}

@Injectable({ providedIn: 'root' })
export class FabricProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric';

  public getByCodesBatch(fabricCodes: string[]): Observable<ApiResponse<FabricDto[]>> {
    return this.httpClient.post<ApiResponse<FabricDto[]>>(`${this.baseUrl}/fabric-code/batch`, fabricCodes);
  }

  public getByCode(fabricCode: string): Observable<ApiResponse<FabricDto>> {
    return this.httpClient.get<ApiResponse<FabricDto>>(`${this.baseUrl}/fabric-code/${encodeURIComponent(fabricCode)}`);
  }

  public search(query: string, pageSize = 50): Observable<ApiResponse<PaginatedApiResponse<FabricDto>>> {
    const params = new HttpParams().set('pageNumber', 1).set('pageSize', pageSize).set('matchAny', true);
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<FabricDto>>>(
      `${this.baseUrl}/search`,
      { fabricCode: query, longDescription: query },
      { params },
    );
  }
}
